import React, { useContext } from "react";
import LeloFormRow from "./LeloFormRow";
import * as FaIcons from "react-icons/fa";
import AdminLeloContext from "../../context/adminLelo/adminLeloContext";

const headers = [
  { name: "createdAt", display: "Submit Date" },
  { name: "status", display: "Status" },
  { name: "firstName", display: "Student Name" },
  { name: "learningCenters", display: "Learning Center" },
  { name: "studentPrimaryPhone", display: "Phone Number" },
  { name: "studentEmail", display: "Email" },
  { name: "uploadedUrl", display: "Signed Agreement" },
  { name: "permaLink", display: "Permalink" },
];

const TableHeaderItem = ({ name, display }) => {
  const adminLeloContext = useContext(AdminLeloContext);
  const { sortOptions, onTableFilter } = adminLeloContext;

  const sortOption = sortOptions[name] || { asc: false, desc: false };

  return (
    <th onClick={() => onTableFilter(name)}>
      <div className="wrap">
        <span>{display}</span>
        <div className="filter">
          <FaIcons.FaSortUp
            className={sortOption.asc ? "sort-icon-asc" : "sort-icon-inactive"}
          />
          <FaIcons.FaSortDown
            className={sortOption.desc ? "sort-icon-desc" : "sort-icon-inactive"}
          />
        </div>
      </div>
    </th>
  );
};

const LeloTable = ({ items }) => {
  const adminLeloContext = useContext(AdminLeloContext);
  const { visibleColumns } = adminLeloContext;

  // Check status for the first item, assuming all rows have the same status
  const status = items[0]?.status;

  // Sort items by createdAt in descending order
  const sortedItems = [...items].sort((a, b) => {
    return new Date(b.createdAt) - new Date(a.createdAt);
  });

  // Filter headers based on visibility and status
  const visibleHeaders = headers.filter((header) => {
    // Check if column is visible in context
    if (visibleColumns && visibleColumns[header.name] === false) {
      return false;
    }
    // Hide "Signed Agreement" if status is "Active"
    if (status === "Active" && header.name === "uploadedUrl") {
      return false;
    }
    return true;
  });

  return (
    <div className="interest-form-table">
      <div className="table-responsive">
        <table className="responsive-table" id="interest-table">
          <thead>
            <tr>
              {visibleHeaders.map((header) => (
                <TableHeaderItem
                  key={header.name}
                  name={header.name}
                  display={header.display}
                />
              ))}
            </tr>
          </thead>
          <tbody>
            {sortedItems.map((item) => (
              <LeloFormRow
                key={item._id}
                info={item}
                visibleColumns={visibleColumns}
                currentStatus={status}
              />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LeloTable;
